module.exports = __webpack_public_path__ + "static/img/products_BioCloud.424ce760.png";